export default __webpack_public_path__ + "media/media/step2_extension-5c53efa9.mp4";